import type { MapBounds, MapLatLng } from "./MapView.types";

export function boundsOf(points: readonly MapLatLng[]): MapBounds | null {
  if (points.length === 0) {
    return null;
  }

  let north = -Infinity;
  let south = Infinity;
  let east = -Infinity;
  let west = Infinity;

  for (const { lat, lng } of points) {
    north = Math.max(north, lat);
    south = Math.min(south, lat);
    east = Math.max(east, lng);
    west = Math.min(west, lng);
  }

  return { north, south, east, west };
}

export function unionOf(all: readonly MapBounds[]): MapBounds | null {
  if (all.length === 0) {
    return null;
  }

  return all.reduce((union, bounds) => ({
    north: Math.max(union.north, bounds.north),
    south: Math.min(union.south, bounds.south),
    east: Math.max(union.east, bounds.east),
    west: Math.min(union.west, bounds.west),
  }));
}

export function isPointBounds({ north, south, east, west }: MapBounds) {
  return north === south && east === west;
}

export function boundsEqual(a: MapBounds | null, b: MapBounds | null) {
  if (a === null || b === null) {
    return a === b;
  }

  return (
    a.north === b.north &&
    a.south === b.south &&
    a.east === b.east &&
    a.west === b.west
  );
}
